import { inject, Injectable } from "@angular/core";
import { BaseWorkflowStateService } from "../base-workflow-state.service";
import { SigfanData } from "../../../../../../models/order/workflow/wireless/sigfan.model";
import { WirelessFlowStateService } from "./wireless-flow-state.service";

@Injectable({ providedIn: 'root' })
export class WirelessSigfanStateService extends BaseWorkflowStateService<SigfanData> {
    private flowStateService = inject(WirelessFlowStateService);
    override stateKey: string = 'sigfan';

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ sigfan: this.state() });
    }

    resetData() {
        this.state.set(null);
        this.saveLocalDraft();
    }
}
